import React from 'react';
import DPDropDown from 'framework/components/DPDropDown';
import { Col, Row, Button, Label } from 'reactstrap';
import DPTextBox from 'framework/components/DPTextBox';
import DPSwitch from 'framework/components/DPSwitch';



const SageIntergrationContent = ({
  ExcelUploadOption,
  selectedExcelOption,
  handleDropdownOnChange,
  disabled,

  handleGenerateExcel,
  handleFileChange,
  fileInputRef,
  setSelectedType,
  selectedType,
  setSelectedExportOption,
  selectedExportOption,
  ExcelExportOptions,
  exportTypes,
  sageTypes,
  selectedSageType,
  setSelectedSageType,
  setCurrentDate,
  currentDate,
  selectedLocation,
  setSelectedLocation,
  setIsAllLocation,
  isAllLocation,
  locationList,
  displayAlertMessage,
  SetLoadingAlerttitle,
  SetLoadingAlert
}) => {


  async function handleDataExport() {
    if (selectedType == "") {
      displayAlertMessage('danger', 'Please select the file type!')
      return;
    }

    if (currentDate == "") {
      displayAlertMessage('danger', 'Please select the date!')
      return;
    }

    if (selectedSageType == "") {
      displayAlertMessage('danger', 'Please select the document type!')
      return;
    }

    if (selectedLocation == "" && isAllLocation == false) {
      displayAlertMessage('danger', 'Please select the location!')
      return;
    }

    //generate file name with selected document type and date

    const fileName = sageTypes.find(x => x.value === selectedSageType).label + "_" + currentDate + "." + selectedType.toLowerCase()

    try {
      const authToken = localStorage.getItem("authToken")
      const ApiURL = window.Links.ApiURL


      SetLoadingAlert(true)
      SetLoadingAlerttitle("Downloading file...")

      const response = await fetch(`${ApiURL}ExcelUpload/sageFile`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${authToken}`,
          "Content-Type": "application/json" // Add Content-Type header
        },
        redirect: "follow",
        body: JSON.stringify({
          date: currentDate,
          docType: selectedSageType,
          fileType: selectedType,
          location: selectedLocation,
          isAllLocation: isAllLocation ? 1 : 0,
          fileName: fileName
        })
      });
      SetLoadingAlert(false)
      // Check if the request was successful (status code in the range of 200-299)
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        // Handle unsuccessful response (status code outside the range of 200-299)
        const errorData = await response.json(); // Assuming the server returns JSON
        console.error('Error:', errorData);
        displayAlertMessage('danger', errorData.error)
      }
    } catch (error) {
      // Handle network errors or other exceptions
      console.error('Fetch error:', error);
      SetLoadingAlert(false)
    }

    // setSelectedType("")
    // setCurrentDate("")
    // setSelectedSageType("")
    // setSelectedLocation("")
    // setIsAllLocation(false)


  }


  return (
    <React.Fragment>

      <Row >
        <Col sm={12} md={6} className="mb-4-sm">
          <DPDropDown
            rowClass="mb-4-sm"
            labelText="File Type"
            textType="text"
            optionGroup={exportTypes}
            selectedGroup={selectedType}
            onChange={(e) => {
              setSelectedType(e["value"])
            }}
            disabled={disabled}
          />
          <DPDropDown
            rowClass="mb-4-sm"
            labelText="Document Type"
            textType="text"
            optionGroup={sageTypes}
            selectedGroup={selectedSageType}
            onChange={(e) => {
              setSelectedSageType(e["value"])
            }}
            disabled={disabled}
          />
          <DPTextBox
            rowClass="mb-4-sm"
            labelText="Date"
            textType="Date"
            value={currentDate}
            onChange={(e) => {
              setCurrentDate(e.target.value)
            }}
            disabled={disabled}
          />

        </Col>

      </Row>
      <Row>
        <Col sm={12} md={6} className="mb-4-sm">
          <DPDropDown
            rowClass="mb-4-sm"
            labelText="Location"
            textType="text"
            optionGroup={locationList}
            selectedGroup={selectedLocation}
            onChange={(e) => {
              setSelectedLocation(e["value"])
            }}
            disabled={isAllLocation}
          />
        </Col>
        <Col sm={12} md={6} className="mb-4-sm">
          <DPSwitch
            labelText="All Locations"
            checked={isAllLocation}
            onChange={(e) => {

              if (e) {
                setSelectedLocation("")
              }

              setIsAllLocation(e)
            }}
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row style={{ marginBottom: "200px" }}>
        <Button color="primary" className="btn-sm" onClick={handleDataExport} disabled={disabled}>
          Download File
        </Button>
      </Row>
    </React.Fragment>
  );
};



export default SageIntergrationContent;
